import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ContabilidadCalendario from './ContabilidadCalendario';
import ContabilidadInfo from './ContabilidadInfo';

const Contabilidad = () => {
  const [fechaSeleccionada, setFechaSeleccionada] = useState(null);
  const [dataDelDia, setDataDelDia] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [dataDelMes, setDataDelMes] = useState(null);


  const handleDateChange = (fecha) => {
    setFechaSeleccionada(fecha);
  };

useEffect(() => {
  const fetchDatos = async () => {
    if (!fechaSeleccionada) return;

    setCargando(true);
    setError(null);
    setDataDelDia(null);
    setDataDelMes(null);

    try {
      const anio = fechaSeleccionada.getFullYear();
      const mes = fechaSeleccionada.getMonth() + 1;
      const dia = fechaSeleccionada.getDate();

      const fechaStr = `${anio}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;

      // Peticiones simultáneas
      const [resDia, resMes] = await Promise.all([
        axios.get(`${process.env.REACT_APP_API_URL}/api/totalpordia?fecha=${fechaStr}`),
        axios.get(`${process.env.REACT_APP_API_URL}/api/totalpormes?anio=${anio}&mes=${mes}`)
      ]);

      console.log('Datos día:', resDia.data);
      console.log('Datos mes:', resMes.data);

      setDataDelDia(resDia.data);
      setDataDelMes(resMes.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Error al obtener datos');
    } finally {
      setCargando(false);
    }
  };

  fetchDatos();
}, [fechaSeleccionada]);

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-md-3">
          <ContabilidadCalendario 
            selectedDate={fechaSeleccionada} 
            onDateChange={handleDateChange} 
          />
        </div>

        <div className="col-md-9">
          <ContabilidadInfo 
            fecha={fechaSeleccionada} 
            datos={dataDelDia} 
            cargando={cargando}
              datosMes={dataDelMes}
            error={error}
          />
        </div>
      </div>
    </div>
  );
};

export default Contabilidad;
